import { atom } from "jotai";

export const tvIsFocusedAtom = atom(false);
